import React from 'react';
import styles from './FooterButtonsLayout.module.scss';
import ToolbarLayout from '../ToolbarLayout';

function FooterButtonsLayout(props) {
    const { className = '', children } = props;

    return <ToolbarLayout className={[className, styles.FooterButtonsLayout].join(' ')}>{children}</ToolbarLayout>;
}

export default FooterButtonsLayout;
